interface ErrorObject {
  message: string | undefined;
  [key: string]: any;
}

export const parseErrorMessageRecursive = (error: ErrorObject): string[] => {
  const errorMessages: string[] = [];

  const parseErrors = (errors: ErrorObject | string[] | null): void => {
    if (errors === null) {
      return;
    }

    if (Array.isArray(errors)) {
      Array.isArray(errors) &&
        errors?.forEach((item) => {
          if (typeof item === 'object' && item !== null) {
            parseErrors(item);
          } else if (typeof item === 'string') {
            errorMessages.push(item);
          }
        });
    } else if (typeof errors === 'object' && errors !== null) {
      Array.isArray(Object.values(errors)) &&
        Object.values(errors)?.forEach((value) => {
          if (typeof value === 'object' && value !== null) {
            parseErrors(value);
          }
          if (typeof value === 'object' && value !== null && 'message' in value) {
            errorMessages.push(value.message);
          }
        });
    }
  };

  parseErrors(error);

  return errorMessages;
};
